<template lang="pug">
  .room-controls
    .room-controls__wrapper
      .room-controls__url
        .room-controls__name
          | {{ url }}
        //- クリップボードにコピー用
        input#js-roomUrl.sr-only(
          type="text",
          :value="url"
        )
        ul.d-flex.mb-0.list-unstyled.room-controls__list
          li.room-controls__item
            button.room-controls__btn(
              type="button",
              @click="copyClipboard"
            )
              i.fas.fa-link.room-controls__icon

      .room-controls__user(v-if="joinMembers")
        img.room-controls__user-icon(src="/static/img/app/icon-user-length.svg")
        .room-controls__user-length
          span.room-controls__active-user {{ joinMembers }}
          | &nbsp;/&nbsp;{{ limitUserLegnth }}
</template>

<script>
export default {
  name: 'Controller',
  props: ['url'],
  computed: {
    limitUserLegnth () {
      // 制限人数
      return this.$store.state.limitMembers
    },
    joinMembers () {
      return this.$store.getters.joinMembers
    }
  },
  methods: {
    copyClipboard () {
      // 連打防止
      let flag = this.$store.state.showAlert

      if (flag) return

      flag = true

      // URLを選択してコピー実行
      const $target = document.getElementById('js-roomUrl')
      $target.select()
      document.execCommand('copy')

      this.$store.dispatch('updateShowAlert', { flag })

      // TODO: alert側で解除してもらうのが筋。アニメーション用のクラスなど見直しの必要あり
      setTimeout(() => {
        flag = false
        this.$store.dispatch('updateShowAlert', { flag })
      }, 4000) // アニメーションの時間が4秒なので
    }
  }
}
</script>
